import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { File as FileModel } from 'src/app/classes/models/file';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-file-upload-modal',
  templateUrl: './file-upload-modal.component.html',
  styleUrl: './file-upload-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FileUploadModalComponent {
  constructor(
    private activeModal: NgbActiveModal,
    private UtilityService: UtilityService,
    private ToastService: ToastService,
    private ChangeDetectorRef: ChangeDetectorRef
  ) {}

  @Input() title?: string;
  @Input() helperText?: string;
  Files: FileModel[] = [];

  removeFile({ index }: { index: number }) {
    this.Files.splice(index, 1);
    this.ChangeDetectorRef.markForCheck();
  }

  fileUpload({ data: File }: { data: File }) {
    const { name: filename, size: filesize, type: filetype } = File;

    from(File.arrayBuffer()).subscribe({
      next: (FileArrayBuffer) => {
        const FileString = `data:${filetype};base64,${this.UtilityService.convertArrayBufferToBase64EncodedString(FileArrayBuffer)}`;

        const uploadedFile = {
          filename,
          filesize,
          filetype,
          FileContent: {
            filecontents: FileString
          }
        };

        this.Files.push(uploadedFile);
        this.ChangeDetectorRef.markForCheck();
      }
    });
  }

  close() {
    this.activeModal.dismiss('Cross Click');
  }

  upload() {
    if (!this.Files || this.Files.length === 0) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot upload file(s). No files found to upload.',
        { returnError: true }
      );
    }

    this.activeModal.close(this.Files);
  }
}
